import { mergeClassName as e } from "../../utils/data.js";
import t from "./InputBox.module.js";
import { inputBoxClassName as n } from "./inputBoxClassName.js";
import { useMemo as r } from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region lib/components/Input/InputBox.tsx
function o({ hasError: o, active: s, prefix: c, suffix: l, boxProps: u, className: d, disabled: f, readOnly: p, readOnlyMuted: m = !0, ...h }) {
	let { className: g, ..._ } = u ?? {}, v = r(() => n({
		hasError: o,
		active: s,
		disabled: f,
		readOnly: p,
		readOnlyMuted: m
	}, g), [
		o,
		f,
		p,
		m,
		s,
		g
	]);
	return /* @__PURE__ */ a("div", {
		className: v,
		"data-disabled": f ?? void 0,
		..._,
		children: [
			c && /* @__PURE__ */ i("span", {
				className: t.adornment,
				"aria-hidden": !0,
				children: c
			}),
			/* @__PURE__ */ i("input", {
				className: e(t.input, d),
				disabled: f,
				readOnly: p,
				...h
			}),
			l && /* @__PURE__ */ i("span", {
				className: t.adornment,
				"aria-hidden": !0,
				children: l
			})
		]
	});
}
//#endregion
export { o as InputBox };
